module.exports = __webpack_public_path__ + "static/media/Icon-Close.42eac793.svg";